import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	interaction__close: 'mw/interaction/close',
	interaction__appeal: 'mw/interaction/appeal',
	interaction__appeal__appoint_repeat: 'mw/interaction/appeal/appoint-repeat',
	interaction__appeal__create: 'mw/interaction/appeal/create',
	interaction__appeal__save: 'mw/interaction/appeal/save',
	interaction__create: 'mw/interaction/create',
	interaction__item__type__list: 'mw/interaction/item/type/list',
};

export const interactionApi = createApi({
	reducerPath: 'mw/interactionApi',

	endpoints: (builder) => ({
		interactionClose: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/close',
				body,
			}),
			providesTags: [tags.interaction__close],
		}),
		interactionAppeal: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/appeal',
				body,
			}),
			providesTags: [tags.interaction__appeal],
		}),
		interactionAppealCreate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/appeal/create',
				body,
			}),
			providesTags: [tags.interaction__appeal__create],
		}),
		interactionAppealAppointRepeat: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/appeal/appoint-repeat',
				jsonType: true,
				body,
			}),
			providesTags: [tags.interaction__appeal__appoint_repeat],
		}),
		interactionAppealSave: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/appeal/save',
				jsonType: true,
				body,
			}),
			providesTags: [tags.interaction__appeal__save],
		}),
		interactionCreate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/interaction/create',
				body,
			}),
			providesTags: [tags.interaction__create],
		}),
		interactionItemTypeList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/interaction/item/type/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.interaction__item__type__list],
		}),
	}),
});

export const {
	interactionClose,
	interactionAppeal,
	interactionAppealAppointRepeat,
	interactionAppealCreate,
	interactionAppealSave,
	interactionCreate,
	interactionItemTypeList,
} = interactionApi.endpoints;

export default interactionApi;
